/** `value.dex`, Orca when absent; an unknown stored value fails closed instead of guessing a DEX. */
export function dexOf(value) {
    const dex = value.dex;
    if (dex === undefined)
        return "orca";
    if (dex === "orca" || dex === "raydium")
        return dex;
    throw new Error("Unsupported DEX");
}
/**
 * The unavailable summary's reason while nothing is captured for this wallet; as
 * `BalanceRead.lastRefresh.reason`, the server has captured nothing since it started.
 */
export const BALANCE_NOT_READ = "positions not read yet";
export const RANGE_WIDTHS = [5, 10, 15, 20, 30];
/** Operator limit defaults and bounds; the server validates and the Start dialog prefills with these. */
export const AUTOPILOT_LIMITS = {
    drawdownPercent: { default: "20", min: "1", max: "90", maxDecimals: 1 },
    entriesPer24h: { default: 10, min: 1, max: 100 },
};
export const PORTFOLIO_RANGES = ["1d", "1w", "1m", "all"];
/** SSE event emitted on every run-state change and journal append; the client refetches. */
export const AUTOPILOT_SSE_EVENT = "autopilot";
/** SSE event on every spot state or journal change; the client reloads the autopilot view. */
export const SPOT_SSE_EVENT = "spot";
